import { createSlice } from "@reduxjs/toolkit";

const SessionArray = createSlice({
  name: "SessionArray",
  initialState: "",
  reducers: {
    saveSessionArray: (state, action) => action.payload,
  },
});

export default SessionArray;
